import React from "react";
import LoginLayout from "../../layouts/LoginLayout";
import AuthCard from "../../components/AuthCard";

const Login = (props: any) => {
    const onLogin = () => {
        props.history.push('/');
    }

    return (
        <LoginLayout>
            <AuthCard onLogin={onLogin}/>
        </LoginLayout>
    );
};

export default Login;
